import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const currentYear = computed(() => new Date().getFullYear());

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (_openBlock(), _createBlock(_component_v_footer, {
    location: "bottom",
    height: "48",
    color: "background",
    class: "text-center",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(currentYear)) + " © Onino ", 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})